import React from "react";
import { Grid, Box, Typography, AppBar, Toolbar, Paper, Container } from "@mui/material";
import MainContentContainer from "../MainContentContainer/MainContentContainer";
import SuggestedSearches from "./SuggestedSearches";
import TopSearch from "./TopSearch";
import SearchDeeplinks from "./SearchDeeplinks";

const SearchPage = () => {
  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Search
          </Typography>
        </Toolbar>
      </AppBar>

      <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Box display="grid" gap={4}>
          <Typography variant="h5" gutterBottom>
            Search Configuration
          </Typography>
          <Box display="grid" gridTemplateColumns={{ xs: '1fr', md: '1fr 2fr' }} gap={3}>
            <Box>
              <Paper elevation={1} sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Top Search
                </Typography>
                <TopSearch />
              </Paper>
            </Box>
            <Box>
              <Paper elevation={1} sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Suggested Searches
                </Typography>
                <SuggestedSearches />
              </Paper>
            </Box>
          </Box>

          <Typography variant="h5" gutterBottom>
            Search Results Deeplinks
          </Typography>
          <Box>
            <Paper elevation={1} sx={{ p: 3 }}>
              <SearchDeeplinks />
            </Paper>
          </Box>
        </Box>
      </Paper>
    </MainContentContainer>
  );
};

export default SearchPage;
